import {isPastDate} from '../../projects/utils/formatDate';

export const UPDATE_APP_INTEG_STATUS = 'UPDATE_APP_INTEG_STATUS';
export const REGENERATE_TOKEN_EVENT = 'REGENERATE_TOKEN_SUCCESS';

export const enableRegenerateToken = (status: string, endDate: any) => {
  const isActive = status === 'Active';
  return isActive && (!endDate || !isPastDate(endDate));
};
